module.exports = __webpack_public_path__ + "img/Unity-Certified-User-Project-Image.73b24952.jpg";